import type { AssignmentReferenceSingleBookingSchema } from "../schemas";
import { generateId } from "../strings";

export function getDefaultBookingAdjustment(booking: AssignmentReferenceSingleBookingSchema) {
	return {
		id: generateId(),
		bookingId: booking.id,
		checkIn: booking.checkIn,
		checkOut: booking.checkOut,
		note: null,
		pause: booking.pause,
		result: null,
	};
}
